import api from './api';
import type {
  PancakePage,
  PancakeOverview,
  PancakeConversation,
  PancakeMessage,
  PancakeCampaignStats,
  PancakeEngagementStats,
  PancakeStaffStats,
  PancakeTagStats,
  PancakeCustomer,
  PancakePost,
} from '../types/pancake';

interface DateRangeParams {
  from: string;
  to: string;
}

interface PaginatedParams extends DateRangeParams {
  page?: number;
  pageSize?: number;
}

interface ConversationParams extends DateRangeParams {
  page_id?: string;
  type?: string;
}

export const pancakeApi = {
  async getPages(): Promise<PancakePage[]> {
    const { data } = await api.get('/pancake/pages');
    return data;
  },

  async getOverview(params: DateRangeParams): Promise<PancakeOverview> {
    const { data } = await api.get('/pancake/overview', { params });
    return data;
  },

  async getConversations(params: ConversationParams): Promise<PancakeConversation[]> {
    const { data } = await api.get('/pancake/conversations', { params });
    return data;
  },

  async getConversationMessages(pageId: string, conversationId: string): Promise<PancakeMessage[]> {
    const { data } = await api.get(`/pancake/conversations/${pageId}/${conversationId}/messages`);
    return data;
  },

  async getCampaignStats(params: DateRangeParams): Promise<PancakeCampaignStats[]> {
    const { data } = await api.get('/pancake/stats/campaigns', { params });
    return data;
  },

  async getAdsStats(params: DateRangeParams): Promise<PancakeCampaignStats[]> {
    const { data } = await api.get('/pancake/stats/ads', { params });
    return data;
  },

  async getEngagementStats(params: DateRangeParams): Promise<PancakeEngagementStats[]> {
    const { data } = await api.get('/pancake/stats/engagement', { params });
    return data;
  },

  async getPagePerformance(params: DateRangeParams): Promise<PancakeEngagementStats[]> {
    const { data } = await api.get('/pancake/stats/page-performance', { params });
    return data;
  },

  async getTagStats(params: DateRangeParams): Promise<PancakeTagStats[]> {
    const { data } = await api.get('/pancake/stats/tags', { params });
    return data;
  },

  async getStaffStats(params: DateRangeParams): Promise<PancakeStaffStats[]> {
    const { data } = await api.get('/pancake/stats/staff', { params });
    return data;
  },

  async getCustomers(params: PaginatedParams): Promise<{ total: number; customers: PancakeCustomer[] }> {
    const { data } = await api.get('/pancake/customers', { params });
    return data;
  },

  async getPosts(params: PaginatedParams): Promise<{ total: number; posts: PancakePost[] }> {
    const { data } = await api.get('/pancake/posts', { params });
    return data;
  },

  async getTags(): Promise<{ id: string; name: string }[]> {
    const { data } = await api.get('/pancake/tags');
    return data;
  },
};
